import { coreAdminClient } from '../apiClient/generated/coreAdminClient';
import { clearSessionCurrencyTypeId } from '../cookie';

interface JumpCompanyArgsWithCompanyId {
  companyGuid?: never;
  companyId: number;
  openInNewWindow?: boolean;
  redirect?: string;
}
interface JumpCompanyArgsWithCompanyGuid {
  companyGuid: string;
  companyId?: never;
  openInNewWindow?: boolean;
  redirect?: string;
}
type JumpCompanyArgs = JumpCompanyArgsWithCompanyGuid | JumpCompanyArgsWithCompanyId;
export async function jumpCompany({
  companyGuid,
  companyId,
  openInNewWindow,
  redirect,
}: JumpCompanyArgs) {
  if (companyId) {
    await coreAdminClient.updateSession({
      companyGuid: null,
      companyId,
    });
  } else if (companyGuid) {
    await coreAdminClient.updateSession({
      companyGuid,
      companyId: null,
    });
  }
  if (companyId || companyGuid) {
    clearSessionCurrencyTypeId();
    const to = redirect ?? window.location.origin;
    if (openInNewWindow) {
      window.open(to, '_blank');
    } else {
      window.location.href = to;
    }
  }
}
